import React, { useEffect, useRef, useState } from "react";
import * as echarts from "echarts";
import { humanlossdougnutchartdata } from "../../../../../Services/EndPoints";
import { getData } from "../../../../../Services/Services";

const COLORS = {
  deaths_count: "#1C4E72",
  incident_count: "#3A85B5",
  injured_count: "#5AA0C0",
  default: "#7A9BB0",
};

const HalfDoughnutChartLoss = ({
  fromDateNew, toDateNew, title, dataKey,
  applyClicked, onApplyHandled, firstLoad, selectedIncident,
}) => {
  const chartRef = useRef(null);
  const chartInstance = useRef(null);
  const [chartData, setChartData] = useState({});

  const fetchChartData = async () => {
    try {
      const incidentId = selectedIncident?.id === 0 ? 0 : selectedIncident?.id || "ALL";
      const data = await getData(
        humanlossdougnutchartdata
          .replace("FROMDATE", fromDateNew).replace("TODATE", toDateNew)
          .replace("ID", incidentId)
      );
      if (data?.[0]) {
        setChartData({
          injured_count: data[0].injured_count || 0,
          incident_count: data[0].incident_count || 0,
          deaths_count: data[0].deaths_count || 0,
        });
      } else {
        setChartData({ injured_count: 0, incident_count: 0, deaths_count: 0 });
      }
    } catch (e) { console.error(e); }
  };

  useEffect(() => { if (firstLoad) fetchChartData(); }, [firstLoad]);
  useEffect(() => { if (applyClicked) { fetchChartData(); onApplyHandled?.(); } }, [applyClicked]);
  useEffect(() => { if (selectedIncident) fetchChartData(); }, [selectedIncident]);

  const value = chartData[dataKey] || 0;
  const formattedValue = value.toLocaleString("en-IN");
  const maxDigits = Math.max(
    (chartData.incident_count || 0).toLocaleString("en-IN").length,
    (chartData.deaths_count || 0).toLocaleString("en-IN").length,
    (chartData.injured_count || 0).toLocaleString("en-IN").length,
  );
  const valueFontSize =
    maxDigits <= 6 ? 24 :
    maxDigits <= 8 ? 20 :
    maxDigits <= 10 ? 17 :
    maxDigits <= 12 ? 14 : 12;

  useEffect(() => {
    if (!chartRef.current) return;
    const color = COLORS[dataKey] || COLORS.default;

    const option = {
      tooltip: { trigger: "item", confine: true },
      series: [{
        type: "pie", radius: ["52%", "72%"],
        startAngle: 180,
        label: { show: false }, labelLine: { show: false },
        emphasis: { scale: true, scaleSize: 4, itemStyle: { shadowBlur: 12, shadowColor: "rgba(0,0,0,.1)" } },
        data: [
          { value, name: title, itemStyle: { color, borderRadius: 4 } },
          { value: Math.max(value * 0.3, 1), name: "", itemStyle: { color: "rgba(42,101,145,.06)" }, emphasis: { disabled: true } },
        ],
      }],
    };

    if (chartInstance.current) chartInstance.current.dispose();
    chartInstance.current = echarts.init(chartRef.current);
    chartInstance.current.setOption(option);
    const resize = () => chartInstance.current?.resize();
    window.addEventListener("resize", resize);
    return () => { window.removeEventListener("resize", resize); chartInstance.current?.dispose(); };
  }, [value, dataKey, title]);

  return (
    <div style={{ width: "100%", height: "100%", minHeight: 180, display: "flex", flexDirection: "column" }}>
      <div ref={chartRef} style={{ width: "100%", flex: 1, minHeight: 120 }} />
      <div style={{ textAlign: "center", padding: "0 8px 14px" }}>
        <div style={{ fontSize: valueFontSize, fontWeight: 800, color: "#0F2D42", lineHeight: 1.2, wordBreak: "break-word" }}>
          {formattedValue}
        </div>
        <div style={{ fontSize: 10, fontWeight: 600, color: "#7A9BB0", marginTop: 2, textTransform: "uppercase", letterSpacing: ".03em" }}>
          {title}
        </div>
      </div>
    </div>
  );
};

export default HalfDoughnutChartLoss;